
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Package, GraduationCap, BookOpen, DollarSign } from "lucide-react";

interface Product {
  id: number;
  codigo_produto: string;
  descricao_produto: string;
  utilizacao: string | null;
  ano_letivo: number;
  serie: string;
  sku: string;
  preco: number;
  status: string;
}

interface ProductCardProps {
  product: Product;
  formatCurrency: (value: number) => string;
}

export const ProductCard = ({ product, formatCurrency }: ProductCardProps) => {
  const getUtilizacaoIcon = (utilizacao: string | null) => {
    if (utilizacao?.toLowerCase() === 'aluno') return BookOpen;
    if (utilizacao?.toLowerCase() === 'professor') return GraduationCap;
    return Package;
  };

  const UtilizacaoIcon = getUtilizacaoIcon(product.utilizacao);

  return (
    <Card className="group hover:shadow-lg transition-all duration-300 hover:scale-105 border-l-4 border-l-primary/20 hover:border-l-primary">
      <CardContent className="p-6">
        <div className="flex items-start justify-between mb-4">
          <div className="flex items-center gap-3">
            <div className="p-2 rounded-lg bg-primary/10 group-hover:bg-primary/20 transition-colors">
              <UtilizacaoIcon className="h-5 w-5 text-primary" />
            </div>
            <div>
              <Badge variant="outline" className="text-xs font-medium">
                {product.codigo_produto}
              </Badge>
            </div>
          </div>
          <Badge variant={product.status === "Ativo" ? "default" : "secondary"}>
            {product.status}
          </Badge>
        </div>

        <div className="space-y-3">
          <h3 className="font-semibold text-foreground line-clamp-2 group-hover:text-primary transition-colors">
            {product.descricao_produto}
          </h3>

          <div className="grid grid-cols-2 gap-3 text-sm">
            <div className="space-y-1">
              <div className="text-muted-foreground">Utilização</div>
              <div className="font-medium">{product.utilizacao || "N/A"}</div>
            </div>
            <div className="space-y-1">
              <div className="text-muted-foreground">Ano Letivo</div>
              <div className="font-medium">{product.ano_letivo}</div>
            </div>
            <div className="space-y-1">
              <div className="text-muted-foreground">Série</div>
              <div className="font-medium">{product.serie}</div>
            </div>
            <div className="space-y-1">
              <div className="text-muted-foreground">SKU</div>
              <div className="font-medium text-xs">{product.sku}</div>
            </div>
          </div>

          <div className="flex items-center justify-between pt-3 border-t">
            <div className="flex items-center gap-2 text-muted-foreground">
              <DollarSign className="h-4 w-4" />
              <span className="text-sm">Preço</span>
            </div>
            <div className="text-xl font-bold text-primary">
              {formatCurrency(product.preco)}
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
